import React from 'react'
import './community.scss'
import { MainHeading , Breadcrumb , Community } from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
const CommunityMain = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "About us", link: "/aboutus" },
    { label: "Community engagement", link: "/aboutus/community" },
  ];
  
  return (
    <>
      <Container>
        {/* Breadcrumb */}
        <Breadcrumb crumbs={breadcrumbs}/>
         
        {/* heading  */}
        <MainHeading title="Community giving"/>

        {/* Layout */}
        <Community/>
        
      </Container>
    </>
  )
}

export default CommunityMain